import { render, staticRenderFns } from "./AccessibleTextInputDatePicker.vue?vue&type=template&id=b538924c"
import script from "./AccessibleTextInputDatePicker.vue?vue&type=script&lang=ts"
export * from "./AccessibleTextInputDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports